/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import styles from "../../dashboard.module.scss";
import AuthContext from "../../../../hooks/authContext";
import CommunicationsCard from "../CommunicationsCard";
import { formDateCustom } from "../../../../services/helpers";
import { getIssuesList } from "../../../../services/apiservices/issues";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

  const IssuesList = React.memo(() => {
    const classes = useStyles();
    const auth = useContext(AuthContext);
    const [issueData, setIssueData] = useState([]);
    const [status, setStatus] = useState("High");
    const [boldData, setBoldData] = useState([]);

    const companyId =
      auth?.userProfile?.role === "companyUser"
        ? auth?.userProfile?.id
        : auth?.userProfile?.companyId;

    const fetchIssueData = useCallback(async () => {
      try {
        const [issuesRes] = await Promise.all([
          new Promise((resolve, reject) => getIssuesList(companyId, resolve, reject)),
        ]);
        const userProfile = auth?.userProfile;
        const isClient = userProfile?.role === "Client";
        const clientId = userProfile?.client;
        const filteredData = issuesRes?.filter(
          (item) =>
            item?.companyId === companyId && (!isClient || item?.client?.id === clientId)
        ) || [];

        const boldItems = filteredData?.filter((item) => !item?.readUser?.includes(auth?.userProfile?.id));
        setBoldData(boldItems);

        const newData = filteredData?.map((item) => ({
          ...item,
          preview: item?.description,
          user: item?.employee?.name || "",
          time: formDateCustom(item?.updatedAt),
        }));
    
        setIssueData(newData);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    }, [companyId, auth?.userProfile]);

    useEffect(() => {
      fetchIssueData();
    }, [fetchIssueData]);

    const sortedIssues = useMemo(() => {
      return issueData
        ?.filter((issue) => issue?.priority === status && issue?.status !== "Closed")
        ?.sort((a, b) => {
          const dateDiff = new Date(b.createdOn) - new Date(a.createdOn);
          if (dateDiff !== 0) return dateDiff;

          const aNumeric = parseInt(a.issueNumber?.match(/\d+/)?.[0] || "0", 10);
          const bNumeric = parseInt(b.issueNumber?.match(/\d+/)?.[0] || "0", 10);
          return bNumeric - aNumeric;
        })
        ?.slice(0, 5);
    }, [issueData, status]);

    return (
      <CommunicationsCard
        icon={<ErrorOutlineIcon className={styles.iconRed} />}
        updates={sortedIssues}
        title="Team Issues"
        count={boldData?.length}
        to="/operations/issues/manage"
        viewAll="/operations/issues/manage"
      />
    );
  });

export default IssuesList;